import { yup } from '@guiker/shared-framework'

import { MultipostListingInquiry } from '../../../../entity'

const userSchema = yup.object<MultipostListingInquiry['user']>({
  name: yup.string().nullable(),
  emailAddress: yup.string().when('proxyEmailAddress', {
    is: (proxyEmailAddress: string) => !!proxyEmailAddress,
    then: yup.string().nullable(),
    otherwise: yup.string().required(),
  }),
  proxyEmailAddress: yup.string().nullable(),
  phoneNumber: yup.string().nullable(),
  firstName: yup.string().required(),
  lastName: yup.string().nullable(),
})

export const createMultipostInquiryPayloadSchema = yup.object({
  user: userSchema.required(),
  channel: yup.string().required(),
  message: yup.string().nullable(),
  listingId: yup.string().required(),
  optionId: yup.string().nullable(),
  emailBody: yup.string().nullable(),
  inquiredAt: yup.string().required(),
  moveInDate: yup.string().nullable(),
  raw: yup.object().nullable(),
  postingUrl: yup.string().nullable(),
})
